<template>
  <div class="box">
    <div
      class="title"
      :style="overSize ? 'font-size:20px;' : 'font-size:16px;height:57px'"
    >
      <span style="min-width: 100px">{{ title }}</span>
      <slot name="tip"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "box",
  props: {
    title: {
      default: "标题",
      type: String,
    },
    overSize: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.box {
  background: #ffffff;
  border-radius: 4px;
  .title {
    width: 100%;
    height: 70px;
    padding: 0 36px;
    font-size: 20px;
    color: #252b3c;
    border-bottom: 2px solid rgba(0, 0, 0, 0.04);
    display: flex;
    align-items: center;
  }
}
</style>
